import {Role} from "dto/Role"
import {useRegisterRole} from "hooks/query/role-query"
import {FormErrorBox} from "common/FormErrorBox"
import {useForm} from "react-hook-form"
import {useEffect} from "react"
import {NotificationType, showNotification} from "common/Notification"

export const RegisterRoleWindow = ({close}: {
    close: () => void,
}) => {
    const registerMutate = useRegisterRole()
    const {register, handleSubmit, formState: {errors}, setFocus} = useForm<Role>()
    const submit = (values: Role) => {
        registerMutate.mutate({
            name: values.name,
            description: values.description
        }, {
            onSuccess: () => {
                showNotification("Role이 추가되었습니다", NotificationType.SUCCESS)
                close()
            },
            onError: () => showNotification("Role을 추가하지 못했습니다")
        })
    }
    useEffect(() => {
        setFocus("name")
    }, [setFocus])
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="modal is-active">
                <div className="modal-background" onClick={close}></div>
                <div className="modal-card model-modal">
                    <header className="modal-card-head has-background-purple">
                        <p className="modal-card-title has-text-white">Role 추가하기</p>
                        <div className="delete is-clickable" aria-label="close" onClick={close}></div>
                    </header>
                    <section className="modal-card-body">

                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">Role Name</div>
                                <div className="column">
                                    <input className="input" type="text" placeholder="Role 이름을 입력하세요"
                                           {...register("name", {
                                               required: "Role 이름을 입력하세요",
                                               pattern: {
                                                   value: /^[a-zA-Z0-9]{4,}$/g,
                                                   message: "Role 이름은 영문,숫자(4글자이상)만 가능합니다"
                                               },
                                           })}
                                    />
                                    <FormErrorBox error={errors.name}/>
                                </div>
                            </div>
                        </div>
                        <div className="hr-line-dashed"></div>
                        <div className="columns mb0">
                            <div className="column columns ">
                                <div className=" stitlebox label">메모</div>
                                <div className="column">
                                    <textarea className="textarea" placeholder="롤에대한 자세한 설명을 입력하세요!" rows={2}
                                              {...register("description")}/>
                                </div>
                            </div>
                        </div>


                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-purple2">Role추가</button>
                        <div className="button" onClick={close}>취소</div>
                    </footer>
                </div>
            </div>
        </form>
    )
}